import fetch from "auth/FetchInterceptor"

const EstimationService = {}

EstimationService.getById = function (id) {
  return fetch({
    url: `/estimation/${id}`,
    method: "get",
  })
}

EstimationService.getAll = function (
  page,
  cardId = null,
  kilometrageMin = null,
  kilometrageMax = null
) {
  let url = `/estimation/partner/getAll?page=${page}&limit=10`

  if (cardId) {
    url = url + `&carId=${cardId}`
  }
  if (kilometrageMin) {
    url = url + `&kilometrageMin=${kilometrageMin}`
  }
  if (kilometrageMax) {
    url = url + `&kilometrageMax=${kilometrageMax}`
  }
  return fetch({
    url: url,
    method: "get",
  })
}

EstimationService.addResponse = function (id, data) {
  return fetch({
    url: `/estimation/partner/response/${id}`,
    method: "put",
    data: data,
  })
}

export default EstimationService
